import script from "./ResumePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumePage.vue?vue&type=script&setup=true&lang=js"

import "./ResumePage.vue?vue&type=style&index=0&id=044ec919&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044ec919"]])

export default __exports__